// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import React from 'react'
import { warning } from 'react-notification-system-redux'
import { SYSTEM_MAINTENANCE_WARNING_NOTIFICATION } from '../constants'
import MaintenanceWindowWarningMessage from '../MaintenanceWindowWarningMessage'

/**
 * displays notification 10 mins before we go into Maintenance Mode.
 * @param {number} timeUntilNextWindow
 * @returns {(function(*): void)|*}
 */
const setApplicationMaintenanceWarningNotification = timeUntilNextWindow => dispatch => {
  // 10 mins before we go into maintenance mode
  const warningNotificationTime = timeUntilNextWindow - (10 * 60000)

  setTimeout(() => {
    dispatch(warning({
      uid: SYSTEM_MAINTENANCE_WARNING_NOTIFICATION,
      title: 'System Maintenance is about to begin.',
      autoDismiss: 0,
      dismissible: false,
      children: (
        <MaintenanceWindowWarningMessage />
      ),
    }))
  }, warningNotificationTime)
}

export default setApplicationMaintenanceWarningNotification
